import {
  REG_ITEM_TYPE_CROWDFUND,
  REG_ITEM_TYPE_GIFT_CARD,
  REG_ITEM_TYPE_FAVOR,
  REG_ITEM_TYPE_GROUP_GIFT,
  REG_ITEM_TYPE_PRODUCT,
} from 'src/constants'
import { RegItem } from 'src/types/regItem'
import getRegItemType from '../../utils/getRegItemType/getRegItemType'
import {
  CashFundBuyingOptions,
  GiftCardBuyingOptions,
  GroupGiftBuyingOptions,
  HelpAndFavorsBuyingOptions,
  ProductBuyingOptions,
} from './variants'

const DETAILS_TRUNCATION_LENGTH = 160

export const getRegItemBuyingOptionsComponent = (
  regItem: RegItem | undefined
) => {
  if (!regItem) return () => null

  const regItemType = getRegItemType(regItem)

  switch (regItemType) {
    case REG_ITEM_TYPE_CROWDFUND:
      return CashFundBuyingOptions
    case REG_ITEM_TYPE_GIFT_CARD:
      return GiftCardBuyingOptions
    case REG_ITEM_TYPE_FAVOR:
      return HelpAndFavorsBuyingOptions
    case REG_ITEM_TYPE_GROUP_GIFT:
      return GroupGiftBuyingOptions
    case REG_ITEM_TYPE_PRODUCT:
      return ProductBuyingOptions
    default:
      return ProductBuyingOptions
  }
}

export const getIsRegItemDetailsVisible = (regItem?: RegItem) => {
  if (!regItem) return false

  return regItem.quantityNeeded > 1 || regItem.description
}

export const getIsShowMoreVisible = (regItem?: RegItem) =>
  (regItem?.description?.length || 0) > DETAILS_TRUNCATION_LENGTH

export const getDetailsText = (
  regItem?: RegItem,
  isDetailsCollapsed?: boolean
) => {
  if (!regItem) return ''

  if (!isDetailsCollapsed) return regItem.description

  return `${regItem.description?.slice(0, DETAILS_TRUNCATION_LENGTH)}...`
}
